import { ScrollTop } from "@/components/commons/ScrollTop";
import { withGuest } from "@/hoc/withGuest";
import { LoginPage } from "@/features/auth/pages/Login";
import { background } from "@/theme/colors";
import { Box } from "@mui/material";

const Login = () => {
  return (
    <Box width="100%" minHeight="100vh" display="flex" justifyContent="center" pt={13} pb={4} bgcolor={background.primary}>
      <ScrollTop />
      <LoginPage />
    </Box>
  );
};

export default withGuest(Login);
